;(function () {
  'use strict'

  angular
    .module('contrast.donut')
    .factory('csDonutConfigService', [
      'CS_DONUT_CONSTANTS',
      csDonutConfigService
    ])

  function csDonutConfigService(CS_DONUT_CONSTANTS) {
    return {
      createConfig: createConfig
    }

    function createConfig(config) {
      var donutConfig = {
        data: config.data || []
      }

      if (angular.isFunction(config.width)) {
        donutConfig.width = config.width
      } else if (angular.isNumber(config.width)) {
        donutConfig.width = function () {
          return config.width
        }
      } else if (angular.isString(config.width)) {
        donutConfig.width = function (d) {
          return d.data[config.width]
        }
      } else {
        donutConfig.width = function () {
          return CS_DONUT_CONSTANTS.DEFAULT_ARC_WIDTH
        }
      }

      if (angular.isFunction(config.maxWidth)) {
        donutConfig.maxWidth = config.maxWidth
      } else if (angular.isNumber(config.maxWidth)) {
        donutConfig.maxWidth = function () {
          return config.maxWidth
        }
      } else if (angular.isString(config.maxWidth)) {
        donutConfig.maxWidth = function (d) {
          return d.data[config.maxWidth]
        }
      }

      if (angular.isFunction(config.selectedWidth)) {
        donutConfig.selectedWidth = config.selectedWidth
      } else if (angular.isNumber(config.selectedWidth)) {
        donutConfig.selectedWidth = function () {
          return config.selectedWidth
        }
      } else if (angular.isString(config.selectedWidth)) {
        donutConfig.selectedWidth = function (d) {
          return d.data[config.selectedWidth]
        }
      } else {
        donutConfig.selectedWidth = function (d) {
          return (
            donutConfig.width(d) * CS_DONUT_CONSTANTS.DEFAULT_SELECTED_ARC_RATIO
          )
        }
      }

      if (angular.isFunction(config.classAccessor)) {
        donutConfig.classAccessor = config.classAccessor
      } else if (angular.isString(config.classAccessor)) {
        donutConfig.classAccessor = function (d) {
          return d.data[config.classAccessor]
        }
      }

      if (angular.isFunction(config.colorAccessor)) {
        donutConfig.colorAccessor = config.colorAccessor
      } else if (angular.isString(config.colorAccessor)) {
        donutConfig.colorAccessor = function (d) {
          return d.data[config.colorAccessor]
        }
      }

      if (angular.isFunction(config.idAccessor)) {
        donutConfig.idAccessor = config.idAccessor
      } else if (angular.isString(config.idAccessor)) {
        donutConfig.idAccessor = function (d) {
          return d.data[config.idAccessor]
        }
      } else {
        donutConfig.idAccessor = function (d) {
          return d.data
        }
      }

      if (angular.isFunction(config.valueAccessor)) {
        donutConfig.valueAccessor = config.valueAccessor
      } else if (angular.isString(config.valueAccessor)) {
        donutConfig.valueAccessor = function (d) {
          return d[config.valueAccessor]
        }
      } else {
        donutConfig.valueAccessor = function (d) {
          return d
        }
      }

      if (angular.isFunction(config.sort)) {
        donutConfig.sort = config.sort
      } else if (angular.isString(config.sort)) {
        donutConfig.sort = function (a, b) {
          return a[config.sort] - b[config.sort]
        }
      } else {
        donutConfig.sort = null
      }

      if (angular.isString(config.tooltipTemplate)) {
        donutConfig.tooltipTemplate = config.tooltipTemplate
      }

      if (angular.isFunction(config.hasTooltip)) {
        donutConfig.hasTooltip = function (d, i) {
          return config.hasTooltip(d, i) ? true : undefined
        }
      }

      return donutConfig
    }
  }
})()
